import React from 'react';
import PropTypes from 'prop-types';

// components
import ConnectionList from 'components/ConnectionList/ConnectionList';
import { Dialog, DialogTitle, DialogContent } from 'ui-connect';

// styles
import styles from './ConnectionDialog.module.css';

const ConnectionDialog = ({
    viewerDisplayName,
    modalOpen,
    onClose,
    title,
    connectionList,
    emptyState,
    isFetching,
    shouldAnimate,
    resetShouldAnimate,
    actionIndex,
    showSpinner,
    forceCloseOnNavigation,
    hasMore,
    fetchNext,
    disableMutualConnection
}) => {
    return (
        <>
            <Dialog open={modalOpen} closeBtn={true} onClose={onClose}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent className={styles.dialogBodyContainer}>
                    <div className={styles.contentWrapper}>
                        <ConnectionList
                            viewerDisplayName={viewerDisplayName}
                            connectionList={connectionList}
                            shouldAnimate={shouldAnimate}
                            resetShouldAnimate={resetShouldAnimate}
                            actionIndex={actionIndex}
                            closeModal={onClose}
                            forceCloseOnNavigation={forceCloseOnNavigation}
                            showSpinner={showSpinner}
                            hasMore={hasMore}
                            fetchNext={fetchNext}
                            disableMutualConnection={disableMutualConnection}
                        />
                    </div>
                    {!isFetching && connectionList.length === 0 && emptyState}
                </DialogContent>
            </Dialog>
        </>
    );
};

ConnectionDialog.defaultProps = {
    viewerDisplayName: '',
    emptyState: null,
    shouldAnimate: false,
    resetShouldAnimate: () => {},
    actionIndex: -1,
    forceCloseOnNavigation: false,
    hasMore: false
};

ConnectionDialog.propTypes = {
    viewerDisplayName: PropTypes.string,
    modalOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    connectionList: PropTypes.array.isRequired,
    isFetching: PropTypes.bool.isRequired,
    showSpinner: PropTypes.bool.isRequired,
    emptyState: PropTypes.element,
    shouldAnimate: PropTypes.bool,
    resetShouldAnimate: PropTypes.func,
    actionIndex: PropTypes.number,
    forceCloseOnNavigation: PropTypes.bool,
    hasMore: PropTypes.bool,
    disableMutualConnection: PropTypes.bool
};

export default ConnectionDialog;
